import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import { Layout, Input, Row, Typography, Card, Spin, Form, Collapse, Select, Col } from "antd";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import appLabel from "../../../config/appLabel";
import appStatic from "../../../config/appStatic";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";

import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const ViewGLA0400 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [glMappingDetail, setGLMappingDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // console.log(glMappingDetail.financialActivityData.name)

  useEffect(() => {
    // console.log(state);
    getDetailById(state);
  }, []);

  const getDetailById = (params) => {
    setIsLoading(true);

    const url = `${definedApi.ViewGlMapping}/${params.key}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objDetail = res;
        setGLMappingDetail(objDetail);

        // ENABLE DELETE BUTTON
        if (BOM.HasPermission("DELETE_FINANCIALACTIVITYACCOUNT")) {
          dispatch({
            type: cnt.RIGHT_DELETE_BTN,
          });
        }

        setIsLoading(false);
      }
    });
  };

  const onApproveReject = (key) => {
    // console.log("key: ", key);
    const url = `${definedApi.ViewGlMapping}/${state.key}`;

    let action = "";
    let label = state.financialActivity;
    let criteria = "";

    switch (key?.toLowerCase()) {
      case "approve":
        action = "Approve ";
        criteria = false;
        break;
      default:
        action = "Reject ";
        criteria = true;
        break;
    }

    let body = {
      method: "PUT",
      disabled: criteria,
      session,
    };

    // console.log(body);return

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        BOM.LoadAlert(cnt.LOAD, "Processing");
        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err.message || err.error);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, BOM.handleSuccessMsg(`${state.financialActivity} account `));
            navigate("/gla0400");
          }
        });
      },
      function () {
        // No button
      }
    );
  };

  const handleOnDelete = () => {
    let action = "Close  ";
    let label = state.financialActivity;
    // console.log(body);return

    Notiflix.Confirm.show("Are you sure?", action + label, "Yes", "No", function () {
      // Yes
      const url = `${definedApi.DeleteGLMappingList}/${state.key}`;

      const body = {
        method: "DELETE",
        session,
      };

      setIsLoading(true);

      BOM.FetchReqAction(
        body,
        url,
        (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, appLabel.deleteGLMappingMsg);
            navigate("/gla0400");
            //STOP LOAD
            setIsLoading(false);
          }
        },
        {
          navigate,
          showCheckerModal: showCheckerApprovalModal,
          onCheckerApproval: (res) => {
            navigate("/gla0400");
            setIsLoading(false);
          },
        }
      );
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true} onDelete={handleOnDelete}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent pageTitle={appLabel.GLMappingdetail} pageItems={appStatic.viewGLMappingItems} />

      <Spin spinning={isLoading} size="large">
        {/* PART 2 DISPLAY CONTENT */}
        <Form form={useForm} layout="vertical" style={{ paddingTop: 20, marginBottom: 50 }}>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            <Card
              style={{
                marginBottom: "2%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
            >
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Form.Item label={<Text strong>{appLabel.financialActivity}</Text>}>
                    <Input
                      // style={{ width: "30vh" }}
                      disabled
                      value={glMappingDetail?.financialActivityData?.name}
                      // value={
                      //   appStatic.financialActivityLabelMapping[
                      //     glMappingDetail?.financialActivityData?.name
                      //   ] || glMappingDetail?.financialActivityData?.name
                      // }
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item label={<Text strong>{appLabel.account}</Text>}>
                    <Input
                      // style={{ width: "30vh" }}
                      disabled
                      value={glMappingDetail?.glAccountData?.name}
                    />
                  </Form.Item>
                </Col>

                <div style={{ width: "30vh" }}></div>
              </Row>
            </Card>
          </Card>
        </Form>

        {/* PART 3 DISPLAY  RECORD STATUS */}
        <RecordStatus authStatus={""} makerID={""} makerDate={""} checkerID={""} checkerDate={""} />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewGLA0400);
